import React, { useEffect, useRef, useState } from 'react';

// LIBS
import { toast } from 'react-toastify';

// SERVICES
import cfac22 from 'js/library/utils/cfac22';
import { convertToMillis, handleModeUrl, separateBase64String } from 'js/library/utils/helpers';
import { convertToDate } from 'js/library/utils/helpers';
import { generateStorePlacesQuery, validateForm } from './cardServices';
import { handleDefaultImages } from './cardImageUtils';

// ASSETS
import cashBackImg from 'styles/assets/cardsGenerico/promocoes-cashback.jpg';
import cashBackImgMobile from 'styles/assets/cardsGenerico/promocoes-cashback-mobile.jpg';
import estabProxImg from 'styles/assets/cardsGenerico/estabelecimentos-proximos.jpg';
import estabProxImgMobile from 'styles/assets/cardsGenerico/estabelecimentos-proximos-mobile.jpg';
import estabSelectImg from 'styles/assets/cardsGenerico/estabelecimentos-selecionados.jpg';
import estabSelectImgMobile from 'styles/assets/cardsGenerico/estabelecimentos-selecionados-mobile.jpg';
import promoProxImg from 'styles/assets/cardsGenerico/promocoes-proximas.jpg';
import promoProxImgMobile from 'styles/assets/cardsGenerico/promocoes-proximas-mobile.jpg';
import promoSelectImg from 'styles/assets/cardsGenerico/promocoes-selecionadas.jpg';
import promoSelectImgMobile from 'styles/assets/cardsGenerico/promocoes-selecionadas-mobile.jpg';
import urlImg from 'styles/assets/cardsGenerico/acessar-url.jpg';
import urlImgMobile from 'styles/assets/cardsGenerico/acessar-url-mobile.jpg';

// COMPONENTS
import ViewModal from './ViewModal';

// APIS
import { createCard, updateCard } from 'js/library/utils/API/apiCards';
import { uploadFiles } from 'js/library/utils/API/apiUploadFiles';

const cardTypes = [
  { label: 'Estabelecimentos', action: 'establishment_list' },
  { label: 'Promoções', action: 'promotion_list' },
  { label: 'Produtos', action: 'product_list' },
];

export function ModalNewCard({
  close,
  openModal,
  arr,
  infosForEdit,
  isNewCard,
  seeInactive,
  data,
  setCardsClub,
  setUpdateData,
}) {
  const clubeData = data;

  const [errorUrl, setErrorUrl] = useState(false);
  const [cardDefault, setCardDefault] = useState(promoProxImg);
  const [cardDefaultDetails, setCardDefaultDetails] = useState(promoProxImgMobile);
  const [query, setQuery] = useState('');
  const [url, setUrl] = useState('');
  const [tags, setTags] = useState([]);
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [maxPriority, setMaxPriority] = useState('');
  const [loading, setLoading] = useState(false);
  const [typeLink, setTypeLink] = useState('new-guide');
  const [isActiveOverflow, setIsActiveOverflow] = useState(true);
  const [chooseDate, setChooseDate] = useState(infosForEdit.enableDate ? true : false);
  const [isPrivateCard, setIsPrivateCard] = useState(infosForEdit.keyWordsSet ? true : false);

  const [selectedCardType, setSelectedCardType] = useState([]);
  const [listType, setListType] = useState('proximos_mim');
  const [appliedFilters, setAppliedFilters] = useState({});

  const [selectedEstablishment, setSelectedEstablishment] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // state que guarda o id do estabelecimento/promoção ou produto que virá selecionado na edição,
  // caso o tipo da listagem seja: selecionados_unitariamente
  const [selectedIdEdit, setSelectedIdEdit] = useState('');
  const [selectedKeywords, setSelectedKeywords] = useState([]);

  const [filesForUpload, setFilesForUpload] = useState({
    thumbDesktop: '',
    mobileDetails: '',
  });

  const [formCard, setFormCard] = useState({
    action: '',
    cardType: 'card_list',
    description: '',
    keywords: [],
    orgs: [],
    platform: ['Web', 'Android', 'iOS'],
    thumbDesktop: '',
    thumbMobile: '',
    mobileDetails: '',
    title: '',
    disableDate: 1988161200000,
    enableDate: '',
    isPublished: seeInactive ? infosForEdit.isPublished : true,
    orderType: 'relevance',
    geoRadius: 1000,
  });

  useEffect(() => {
    if (selectedKeywords.length === 0) {
      setIsPrivateCard(false);
    } else {
      setIsPrivateCard(true);
    }
  }, [selectedKeywords]);

  // imagens
  const modalRef = useRef();
  const setScrollPosition = (element, scroll) => {
    element.current.scrollTop = scroll;

    if (scroll === 0) setIsActiveOverflow(false);
    else setIsActiveOverflow(true);
  };

  // formCard.action
  function handleAction(event) {
    setFormCard({
      ...formCard,
      action: event.target.value,
    });
  }

  // tipo do cards: lista ou url
  function handleChangeTypeCard(event) {
    setFormCard({
      ...formCard,
      cardType: event.target.value,
    });
  }

  // campo: visível apenas para membros?
  function handlePrivacityCard(event) {
    const isChecked = event.target.checked;
    setIsPrivateCard(isChecked);
    setSelectedKeywords(isChecked ? formCard.keywords : []);
  }

  // card ativo
  function handlePublished(event) {
    setFormCard({ ...formCard, isPublished: event.target.checked });
  }

  // edição: preenche o campo tipo de card com o valor correto ao abrir a edição
  const detectCardType = (storePlacesQuery) => {
    if (!storePlacesQuery) return null;

    if (storePlacesQuery.establishmentType) return 'establishment_list';
    if (storePlacesQuery.promotionType) return 'promotion_list';
    if (storePlacesQuery.productType) return 'product_list';

    return null;
  };

  // edição: preenche o campo tipo de listagem com o valor correto ao abrir a edição
  const detectListType = (systemQuery) => {
    if (!systemQuery)
      return {
        listType: 'proximos_mim',
        tags: [],
        selectedId: '',
      };

    // Verifica todos os grupos
    for (const groupName in systemQuery) {
      const group = systemQuery[groupName];
      if (!Array.isArray(group)) continue;

      for (const condition of group) {
        // PointsBack - tem prioridade
        if (
          condition.field === 'tags' &&
          Array.isArray(condition.value) &&
          condition.value.length === 1 &&
          condition.value[0] === 'awin'
        ) {
          return {
            listType: 'pointsback',
            tags: condition.value,
            selectedId: '',
          };
        }

        // Caso de tags normais
        if (condition.field === 'tags' && Array.isArray(condition.value)) {
          return {
            listType: 'selecionados_tag',
            tags: condition.value,
            selectedId: '',
          };
        }

        // Outros tipos
        if (condition.field === 'endereco') {
          return {
            listType: 'proximos_mim',
            tags: [],
            selectedId: '',
          };
        }
        if (condition.field === 'establishmentId' || condition.field === 'id') {
          return {
            listType: 'selecionados_unitariamente',
            tags: [],
            selectedId: condition.value || '', // Extrai o ID aqui
          };
        }
      }
    }

    return {
      listType: 'proximos_mim',
      tags: [],
      selectedId: '',
    };
  };

  // Trás informações para o form quando escolhe a função editar card.
  useEffect(() => {
    async function getInfos() {
      if (!isNewCard && infosForEdit && Object.keys(infosForEdit).length !== 0) {
        // Detecta o tipo do card automaticamente
        const detectedType = detectCardType(infosForEdit.storePlacesQuery);

        // Detecta o tipo de listagem automaticamente
        const { listType, tags, selectedId } = detectListType(
          infosForEdit.storePlacesQuery?.systemQuery
        );

        setListType(listType);
        setTags(tags);
        setSelectedIdEdit(selectedId);

        setFormCard({
          ...formCard,
          keywords: data.keywords,
          orgs: data.orgs,
          action: infosForEdit.action,
          cardType: infosForEdit.type,
          description: infosForEdit.description,
          disableDate:
            infosForEdit.disableDate === 1988161200000
              ? ''
              : convertToDate(infosForEdit.disableDate),
          enableDate: infosForEdit.enableDate === 0 ? '' : convertToDate(infosForEdit.enableDate),
          thumbDesktop: infosForEdit?.images?.web,
          thumbMobile: infosForEdit?.images?.mobile,
          mobileDetails: infosForEdit?.images?.mobileDetails,
          title: infosForEdit.title,
          geoRadius: infosForEdit.geoRadius ?? 1000,
          orderType: infosForEdit.orderType ?? infosForEdit.storePlacesQuery?.orderType ?? '',
        });

        setSelectedKeywords(infosForEdit.keyWordsSet || []);

        // Atualiza o selectedCardType com base no tipo detectado
        if (detectedType) {
          setSelectedCardType(cardTypes.find((card) => card.action === detectedType));
        }

        const VerifyPathWeb = infosForEdit?.images?.web.includes('cards/')
          ? infosForEdit.images.web
          : `cards/${infosForEdit.images.web}`;

        setCardDefault(cfac22('STORAGE_URL') + encodeURIComponent(VerifyPathWeb) + '?alt=media');

        const VerifyPathMobile = infosForEdit.images.mobileDetails?.includes('cards/')
          ? infosForEdit.images.mobileDetails
          : `cards/${infosForEdit.images.mobileDetails}`;

        setCardDefaultDetails(
          cfac22('STORAGE_URL') + encodeURIComponent(VerifyPathMobile) + '?alt=media'
        );

        if (Object.keys(infosForEdit).length !== 0) {
          if (infosForEdit?.appFilter?.url) {
            let url = infosForEdit.appFilter.url;

            if (url?.indexOf('/pagina-completa/') > 0) {
              setTypeLink('full-frame');
              url = decodeURIComponent(new URL(url).searchParams.get('url')) ?? '';
            } else if (url.indexOf('/pagina-interna/') > 0) {
              setTypeLink('inside-frame');
              url = decodeURIComponent(new URL(url).searchParams.get('url')) ?? '';
            }

            // Verifica se a URL começa com "https://"
            if (!url.startsWith('https://')) {
              // Se não começar, adiciona "https://"
              url = 'https://' + url;
            }
            setUrl(url);
          } else if (infosForEdit?.appFilter?.query) {
            setQuery(infosForEdit.appFilter.query);
          }
        }
      } else {
        setFormCard({
          action: '',
          cardType: 'card_list',
          description: '',
          keywords: data.keywords,
          orgs: data.orgs,
          platform: ['Web', 'Android', 'iOS'],
          thumbDesktop: '',
          thumbMobile: '',
          mobileDetails: '',
          title: '',
          disableDate: 1988161200000,
          enableDate: '',
          isPublished: infosForEdit.enableDate ? false : true,
        });

        setUrl('');
        setQuery('');

        setFilesForUpload({
          ...filesForUpload,
          thumbDesktop: '',
          mobileDetails: '',
        });
      }

      // Limpa imagens caso o usuário feche modal após fazer upload da imagem
      if (!openModal) {
        setFilesForUpload({
          ...filesForUpload,
          thumbDesktop: '',
          mobileDetails: '',
        });
      }
    }
    getInfos();
  }, [infosForEdit, isNewCard, openModal]);

  // lat, long
  navigator.geolocation.getCurrentPosition(function (position) {
    setLatitude(position.coords.latitude);
    setLongitude(position.coords.longitude);
  });

  // campos de data
  function handleDateDefined(event) {
    setChooseDate(event.target.checked);
  }

  // campos de data
  const handleDates = (type) => (event) => {
    switch (type) {
      case 'enableDate':
        setFormCard({ ...formCard, enableDate: event.target.value });
        break;
      case 'disableDate':
        setFormCard({ ...formCard, disableDate: event.target.value });
    }
  };

  //VERIFICA QUAL O MAIOR PRIORITY DOS CARDS ATUALMENTE ATIVOS
  useEffect(() => {
    const biggestValue = arr.reduce((maxPriority, item) => {
      return item.priority > maxPriority ? item.priority : maxPriority;
    }, 0);

    setMaxPriority(biggestValue);
  }, [arr]);

  // imagens
  useEffect(() => {
    if (!isNewCard) return;
    const generateBase64 = async () => {
      try {
        const [firstImgRes, secoundImgRes] = await Promise.all([
          fetch(cardDefault),
          fetch(cardDefaultDetails),
        ]);
        const firstBlob = await firstImgRes.blob();
        const secoundBlob = await secoundImgRes.blob();

        const reader = new FileReader();
        const secoundReader = new FileReader();
        reader.readAsDataURL(firstBlob);
        secoundReader.readAsDataURL(secoundBlob);

        reader.onloadend = () => {
          setCardDefault(reader.result);
        };

        secoundReader.onloadend = () => {
          setCardDefaultDetails(secoundReader.result);
        };
      } catch (error) {
        console.error('Erro ao buscar a imagem:', error);
      }
    };

    generateBase64();
  }, [isNewCard]);

  //imagens
  const uploadImage = async (image, typeImg) => {
    const newImage = separateBase64String(image);
    let imageCardPath;

    await uploadFiles('cards', {
      mimeType: newImage.mimeType,
      fileName: 'clubeCards_' + typeImg + '_' + data.clubeId,
      buffer: newImage.buffer,
    })
      .then((res) => {
        const response = res.split('/');
        imageCardPath = 'cards/' + response[response.length - 1].split('?')[0];
      })
      .catch((error) => {
        console.error(error);
      });
    return imageCardPath;
  };

  // imagens
  useEffect(() => {
    switch (formCard.cardType) {
      case 'card_url':
        if (!cardDefault.includes('base64') && !cardDefault.includes('https')) {
          setCardDefault(urlImg);
        }
        if (!cardDefaultDetails.includes('base64') && !cardDefaultDetails.includes('https')) {
          setCardDefaultDetails(urlImg);
        }
        setFormCard({
          ...formCard,
          thumbDesktop: isNewCard ? 'cards/acessar-url.jpg' : infosForEdit.images.web,
          thumbMobile: isNewCard ? 'cards/acessar-url.jpg' : infosForEdit.images.mobile,
          mobileDetails: isNewCard
            ? 'cards/acessar-url-mobile.jpg'
            : infosForEdit.images.mobileDetails,
        });
        break;
    }
  }, [query, formCard.cardType, isNewCard]);

  //imagens
  useEffect(() => {
    if (cardDefault === '') {
      formCard.thumbDesktop = '';
    } else {
      formCard.thumbDesktop = isNewCard ? formCard.thumbDesktop : infosForEdit.images.web;
    }

    if (cardDefaultDetails === '') {
      formCard.mobileDetails = '';
    } else {
      formCard.mobileDetails = isNewCard
        ? formCard.mobileDetails
        : infosForEdit.images.mobileDetails;
    }
  }, [cardDefault, cardDefaultDetails, formCard]);

  // para imagens default
  useEffect(() => {
    handleDefaultImages(
      isNewCard,
      formCard,
      promoProxImg,
      promoProxImgMobile,
      urlImg,
      urlImgMobile,
      estabProxImg,
      estabProxImgMobile,
      estabSelectImg,
      estabSelectImgMobile,
      cashBackImg,
      cashBackImgMobile,
      promoSelectImg,
      promoSelectImgMobile,
      listType,
      setCardDefault,
      setCardDefaultDetails,
      setFormCard
    );
  }, [isNewCard, formCard.cardType, formCard.action, listType]);

  // url: mascara
  function handleMaskUrl(event) {
    const enteredUrl = event.target.value.trim();
    const formattedUrl = handleModeUrl(enteredUrl);

    setUrl(formattedUrl);
    setFormCard({ ...formCard, action: 'browser' });
  }

  async function generateNewCard(e) {
    e.preventDefault();
    setLoading(true);

    const date = Date.now();
    const twentyFourHours = 86400000;
    let urlFrame;

    // Configuração do URL frame apenas para card_url
    if (formCard.cardType === 'card_url') {
      if (typeLink === 'inside-frame') {
        urlFrame = `https://${clubeData.clubeId}${
          clubeData.url
        }/pagina-interna/?url=${encodeURIComponent(url)}`;
      } else if (typeLink === 'full-frame') {
        urlFrame = `https://${clubeData.clubeId}${
          clubeData.url
        }/pagina-completa/?url=${encodeURIComponent(url)}`;
      }
    }

    let keyWordsSet = infosForEdit.keyWordsSet ?? [];
    if (isPrivateCard) {
      formCard.keywords.forEach((item) => {
        if (!keyWordsSet.includes(item)) keyWordsSet.push(item);
      });
    } else {
      keyWordsSet = keyWordsSet.filter((item) => !formCard.keywords.includes(item));
    }

    //payload
    let data = {
      ...formCard,
      enableDate: !chooseDate
        ? 0
        : formCard.enableDate === ''
        ? date - twentyFourHours
        : convertToMillis(formCard.enableDate),
      disableDate: !chooseDate
        ? 1988161200000
        : formCard.disableDate === 1988161200000
        ? formCard.disableDate
        : convertToMillis(formCard.disableDate),
      location: {
        longitude,
        latitude,
        radius: formCard.geoRadius || 8000,
      },
      orgs: formCard.orgs,
      keyWordsSet: keyWordsSet,
      images: {
        mobile: cardDefault.includes('base64')
          ? await uploadImage(cardDefault, 'mobile')
          : infosForEdit.images?.mobile || '',
        web: cardDefault.includes('base64')
          ? await uploadImage(cardDefault, 'web')
          : infosForEdit.images?.web || '',
        mobileDetails: cardDefaultDetails.includes('base64')
          ? await uploadImage(cardDefaultDetails, 'mobileDetails')
          : infosForEdit.images?.mobileDetails || '',
      },
      priority: isNewCard ? maxPriority + 1 : infosForEdit.priority,
      type: formCard.cardType,
    };

    if (formCard.cardType === 'card_list') {
      const { storePlacesQuery } = generateStorePlacesQuery(
        listType,
        tags,
        selectedEstablishment,
        selectedStore,
        selectedProduct,
        formCard,
        appliedFilters
      );

      // Adiciona o tipo correto dentro do storePlacesQuery baseado na action
      switch (formCard.action) {
        case 'establishment_list':
          if (formCard.establishmentType) {
            storePlacesQuery.establishmentType = formCard.establishmentType;
          }
          break;
        case 'promotion_list':
          if (formCard.promotionType) {
            storePlacesQuery.promotionType = formCard.promotionType;
          }
          break;
        case 'product_list':
          if (formCard.productType) {
            storePlacesQuery.productType = formCard.productType;
          }
          break;
        default:
          break;
      }

      delete data.orderType;

      if (!storePlacesQuery.systemQuery || Object.keys(storePlacesQuery.systemQuery).length === 0) {
        delete data.storePlacesQuery;
      }

      data = {
        ...data,
        appFilter: {
          query: query,
        },
        keyWordsSet: selectedKeywords,
        action: formCard.action,
        storePlacesQuery,
      };

      if (!query) {
        delete data.appFilter;
      }
      if (storePlacesQuery && storePlacesQuery.geoRadius < 1000) {
        delete data.storePlacesQuery.geoRadius;
      }
    } else if (formCard.cardType === 'card_url') {
      data = {
        ...data,
        appFilter: {
          url: urlFrame ?? url,
        },
      };
    }

    setTimeout(() => {
      setLoading(false);
    }, 1000);

    // Remover campos não utilizados
    const fieldsToDelete = [
      'keywords',
      'thumbDesktop',
      'thumbMobile',
      'mobileDetails',
      'cardType',
      'label',
      'geoRadius',
      'establishmentType',
      'promotionType',
      'productType',
    ];

    // Remove campos da lista ou que estão vazios
    Object.keys(data).forEach((key) => {
      const value = data[key];

      const isEmpty =
        value === undefined ||
        value === null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);

      if (fieldsToDelete.includes(key) || isEmpty) {
        delete data[key];
      }
    });

    try {
      // Validação dos campos obrigatórios
      const isValid = validateForm(data, formCard.cardType, url, setErrorUrl, setLoading);
      if (!isValid) return;

      // Criar ou atualizar o card
      await handleCardCreationOrUpdate(data);
      if (!loading) close();
    } catch (error) {
      setLoading(false);
      toast.error(
        'Verifique se todos os campos foram preenchidos adequadamente, caso o erro persista, entre em contato com nosso suporte.'
      );
    }
  }

  async function handleCardCreationOrUpdate(data) {
    if (Object.keys(infosForEdit).length === 0 || isNewCard) {
      const createSuccessfull = await createCard(data);
      if (createSuccessfull.data.success) {
        setUpdateData(true);
        setCardsClub((prev) => [
          ...prev,
          {
            id: createSuccessfull?.data?.result,
            cardId: createSuccessfull?.data?.result,
            ...data,
          },
        ]);
        toast.success('Card criado com sucesso!');
      }
    } else {
      const updateSuccessfull = await updateCard(infosForEdit.cardId, data);
      if (updateSuccessfull.data.success) {
        setUpdateData(true);
        setCardsClub((prev) =>
          prev.map((item) =>
            item.id === infosForEdit.cardId
              ? { id: infosForEdit.cardId, cardId: infosForEdit.cardId, ...data }
              : item
          )
        );
        toast.success('Card atualizado com sucesso!');
      }
    }
  }

  return (
    <ViewModal
      openModal={openModal}
      close={close}
      modalRef={modalRef}
      isActiveOverflow={isActiveOverflow}
      setIsActiveOverflow={setIsActiveOverflow}
      generateNewCard={generateNewCard}
      infosForEdit={infosForEdit}
      formCard={formCard}
      setFormCard={setFormCard}
      handleChangeTypeCard={handleChangeTypeCard}
      isNewCard={isNewCard}
      tags={tags}
      setTags={setTags}
      url={url}
      errorUrl={errorUrl}
      setUrl={setUrl}
      handleMaskUrl={handleMaskUrl}
      typeLink={typeLink}
      setTypeLink={setTypeLink}
      cardDefault={cardDefault}
      setCardDefault={setCardDefault}
      setScrollPosition={setScrollPosition}
      cardDefaultDetails={cardDefaultDetails}
      setCardDefaultDetails={setCardDefaultDetails}
      chooseDate={chooseDate}
      handleDates={handleDates}
      handleDateDefined={handleDateDefined}
      isPrivateCard={isPrivateCard}
      handlePrivacityCard={handlePrivacityCard}
      handlePublished={handlePublished}
      loading={loading}
      cardTypes={cardTypes}
      selectedCardType={selectedCardType}
      setSelectedCardType={setSelectedCardType}
      handleAction={handleAction}
      listType={listType}
      setListType={setListType}
      setAppliedFilters={setAppliedFilters}
      selectedEstablishment={selectedEstablishment}
      setSelectedEstablishment={setSelectedEstablishment}
      selectedStore={selectedStore}
      setSelectedStore={setSelectedStore}
      selectedProduct={selectedProduct}
      setSelectedProduct={setSelectedProduct}
      selectedIdEdit={selectedIdEdit}
      selectedKeywords={selectedKeywords}
      setSelectedKeywords={setSelectedKeywords}
    />
  );
}
